import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import PublicFormViewPage from './pages/public/PublicFormViewPage';
import { trimTrailingSlashes } from './utils/safeString';

const PUBLIC_FORM_VIEW_PATH = '/public/form-view';

function isPublicFormViewPath(pathname) {
  const clean = trimTrailingSlashes(pathname || '');
  return clean === PUBLIC_FORM_VIEW_PATH;
}

const shouldRenderPublicFormView = isPublicFormViewPath(window.location.pathname);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {shouldRenderPublicFormView ? <PublicFormViewPage /> : <App />}
  </React.StrictMode>
);
